import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_hero_icon = _resolveComponent("hero-icon")!

  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    disabled: _ctx.disabled,
    class: _normalizeClass(['btn space-x-1', {
    'btn-outline': _ctx.outline,
    'btn-primary': _ctx.type === 'primary',
    'btn-secondary': _ctx.type === 'secondary',
    'btn-accent': _ctx.type === 'accent',
    'btn-ghost': _ctx.type === 'ghost',
    'btn-link': _ctx.type === 'link',
    'btn-info': _ctx.type === 'info',
    'btn-success': _ctx.type === 'success',
    'btn-warning': _ctx.type === 'warning',
    'btn-error': _ctx.type === 'error' || _ctx.color === 'error',
    'btn-sm': _ctx.size === 'small',
    'btn-lg': _ctx.size === 'large',
    'btn-xs': _ctx.size === 'tiny',
    'btn-xs sm:btn-sm md:btn-md lg:btn-lg': _ctx.responsive,
    'btn-disabled': _ctx.disabled,
    'loading': _ctx.loading,
    'btn-square': _ctx.square,
    'btn-circle': _ctx.circle
  }])
  }, [
    (_ctx.icon && !_ctx.loading)
      ? (_openBlock(), _createBlock(_component_hero_icon, {
          key: 0,
          name: _ctx.icon,
          size: _ctx.size
        }, null, 8, ["name", "size"]))
      : _createCommentVNode("", true),
    (_ctx.$slots.default)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}